export const BACKGROUND_REMOVAL_ATTACHMENT_SUFFIX = '-backgroundRemoval';

/**
 * Builds the synthetic attachment id used while uploading a background-removed image.
 */
export const getBackgroundRemovalAttachmentId = (elementId: string): string =>
    `${elementId}${BACKGROUND_REMOVAL_ATTACHMENT_SUFFIX}`;

/**
 * Identifies synthetic background-removal attachment progress entries.
 */
export const isBackgroundRemovalAttachmentId = (attachmentId?: string): boolean =>
    !!attachmentId?.endsWith(BACKGROUND_REMOVAL_ATTACHMENT_SUFFIX);
